import { render, staticRenderFns } from "./PageTherapistClientPayment.vue?vue&type=template&id=5b8d7a96"
import script from "./PageTherapistClientPayment.vue?vue&type=script&lang=js"
export * from "./PageTherapistClientPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports